
import { Component, Vue } from 'vue-property-decorator';
import OsResetPasswordForm from '@/components/shared/password/OsResetPasswordForm.vue';
@Component({
  components: {
    OsResetPasswordForm
  }
})
export default class SetPasswordTokenIndex extends Vue {}
